export default [
   {
      path: '/dashboard', // entry point
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
   },
]
